<div class="container">
    <div class="wrapper">
        <h1 class="pageTitle" id="main-content" >
            {{pageTitle}}</h1>
        <h2 class="govuk-heading-m">{{verifyPageText}}</h2>
        @if(webhookResponseStatus) {
          <p class="govuk-body-l">{{ webhookResponseStatus | translate }}</p>
        }

    </div>
</div>

@if(paymentReceived) {
  <div class="govuk-grid-column-two-thirds">
    <p class="govuk-body">Your booking is being finalised and you will receive a confirmation email shortly.</p>
    @if(receipt) {
      <p class="govuk-body">Receipt number: {{ receipt }}</p>
    }
    @if(ref) {
      <p class="govuk-body">Payment reference: {{ ref }}</p>
    }
  </div>
}

@if(failed) {
  <div class="govuk-grid-column-two-thirds">
    <h2 class="govuk-heading-l">Sorry, there has been a problem</h2>
    @if(failureDescription) {
      <p class="govuk-body">{{ failureDescription }}</p>
    }
    <p class="govuk-body">You have not been charged. You can start your booking again.</p>
    @if(receipt) {
      <p class="govuk-body">Receipt: {{ receipt }}</p>
    }
    @if(ref) {
      <p class="govuk-body">Internal ref: {{ ref }}</p>
    }
    <button class="govuk-button" (click)="restartJourney()">Start again</button>
  </div>
}